import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_mst_entity_payment_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  account_type: fromDatatype.VarcharDatatypeInterface;
  account_number: fromDatatype.VarcharDatatypeInterface;
  account_name: fromDatatype.VarcharDatatypeInterface;
  account_expiry: fromDatatype.TimestampTzDatatypeInterface;
  swift_code: fromDatatype.VarcharDatatypeInterface;
  spending_limit_json: fromDatatype.JsonDatatypeInterface;
  ibn_number: fromDatatype.VarcharDatatypeInterface;
  bank_name: fromDatatype.VarcharDatatypeInterface;
  residential_status: fromDatatype.VarcharDatatypeInterface;
  bank_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bank_code: fromDatatype.VarcharDatatypeInterface;

  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config : fromDatatype.JsonDatatypeInterface;
  acl_policy : fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
}

export class bl_fi_mst_entity_payment_method_RowClass implements bl_fi_mst_entity_payment_method_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  country_code: fromDatatype.VarcharDatatypeInterface;
  payment_provider_code: fromDatatype.VarcharDatatypeInterface;
  account_type: fromDatatype.VarcharDatatypeInterface;
  account_number: fromDatatype.VarcharDatatypeInterface;
  account_name: fromDatatype.VarcharDatatypeInterface;
  account_expiry: fromDatatype.TimestampTzDatatypeInterface;
  swift_code: fromDatatype.VarcharDatatypeInterface;
  spending_limit_json: fromDatatype.JsonDatatypeInterface;
  ibn_number: fromDatatype.VarcharDatatypeInterface;
  bank_name: fromDatatype.VarcharDatatypeInterface;
  residential_status: fromDatatype.VarcharDatatypeInterface;
  bank_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bank_code: fromDatatype.VarcharDatatypeInterface;

  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config : fromDatatype.JsonDatatypeInterface;
  acl_policy : fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid : fromDatatype.GuidDataFieldInterface;
  created_date : fromDatatype.TimestampTzDatatypeInterface;
  updated_date : fromDatatype.TimestampTzDatatypeInterface;
}
